import z from "zod";

export const SupplierFormSchema = z.object({
    email: z.string().email().min(1, "Email is required"),
    full_name: z.string().min(1, "Full name is required"),
    full_name_ar: z.string(),
    short_code: z.string(),
    locations: z
        .array(
            z.object({
                value: z.string().min(1, "Location value is required"),
            }),
        )
        .min(1, "At least one location is required"),
    phone_number: z.string().min(1, "Phone number is required"),
    cr_number: z.string().min(1, "CR number is required"),
    vat_number: z.string().min(1, "VAT number is required"),
    // vendor_code: z.string().min(1, "Vendor Code is required").nullable(),
    iban: z.string().min(1, "IBAN number is required"),
    bank_name: z.string().min(1, "Bank name is requried"),
    account_number: z.string().min(1, "Bank name is requried"),
    company_address: z.string().min(2, "Address is required"),
    address_ar: z.string(),
    assigned_supplier_ids: z
        .union([z.string(), z.array(z.string())])
        .transform((val) => {
            if (Array.isArray(val)) return val;
            if (typeof val === "string" && val.trim() !== "") return [val];
            return null;
        })
        .nullable(),
    representatives: z
        .array(
            z.object({
                id: z.string().nullable(),
                email: z
                    .string()
                    .email()
                    .min(1, "Representative email is required"),
                full_name: z.string().min(1, "Representative name is required"),
                phone_number: z
                    .string()
                    .min(1, "Representative phone number is required"),
            }),
        )
        .min(1, "At least one representative is required"),
    website: z.string().url("Invalid URL").or(z.literal("")),
});

export const CreateSupplierSchema = SupplierFormSchema.omit({
    locations: true,
}).extend({
    locations: z.array(z.string()),
});

export type SupplierFormSchema = z.infer<typeof SupplierFormSchema>;
export type CreateSupplierSchema = z.infer<typeof CreateSupplierSchema>;

export const GenerateOnboardLinkSchema = z.object({
    user_id: z.string().min(1, "AR Coordinator is required"),
});

export type GenerateOnboardLinkSchema = z.infer<
    typeof GenerateOnboardLinkSchema
>;
